const news_data = [

    {
        id: 1,
        slug: "gaming-industr-trends-in-2023",
        text: 'If you haven’t been paying attention to the gaming industry now is the time to start...',
        title: 'Gaming Industry Trends We Think You Should Watch Out For in 2023',
        image: '/images/blog/post_1.jpg',
        date: '5 Feb',
        time: '3 min read',
    },

    {
        id: 2,
        slug: '11-ways-to-engage-with-your-viewers',
        text: 'Viewer engagement is one of the hallmarks for streamer success...',
        title: '11 Ways to Engage with Your Viewers While Streaming',
        image: '/images/blog/post_2.jpg',
        date: '18 Jan',
        time: '3 min read',
    },
    {
        id: 3,
        slug: 'the-future-of-streaming',
        text: 'Whether or not you saw it as a benefit, or a cursed wish, over the pandemic...',
        title: 'The Future of Streaming',
        image: '/images/blog/post_3.jpg',
        date: '22 Feb',
        time: '3 min read',
    },
    {
        id: 4,
        slug: 'future-of-streaming-1',
        text: 'It\'s more than a tool to me. - Tateshi',
        title: 'Future of Streaming Podcast #1: Redefining Creativity in Streaming as a Vtuber',
        image: '/images/blog/post_4.png',
        date: '23 Mar',
        time: '11 min read',

    },
    {
        id: 5,
        slug: 'named-top-startup-by-ventures-canada-press-release',
        text: 'We have been named one of the top 15 startups in Ontario, Canada by Ventures Canada...',
        title: 'mtion interactive Ranked as the Top Startup in Ontario Canada by Canada Ventures',
        image: '/images/blog/post_5.png',
        date: '29 Mar',
        time: '4 min read',

    },
    {
        id: 6,
        slug: 'ten-tips-on-mtion-studio',
        text: 'When using mtion studio the only limit is your imagination.',
        title: '10 Tips on mtion studio',
        image: '/images/blog/post_6.png',
        date: '11 Apr',
        time: '5 min read',

    },
];

const single_news_data = [{
    "id": news_data[0].slug,
    "text": "If you haven’t been paying attention to the gaming industry now is the time to start...",
    "title": "Gaming Industry Trends We Think You Should Watch Out For in 2023",
    "image": "/images/blog/post_1.jpg",
    "date": "2 Feb",
    "time": "5 min read",
    "subImages": [
        "/images/blog/gallery_1_1.png",
        "/images/blog/gallery_1_2.png"
    ],
    "authorImage": "/images/blog/author_large.jpg",
    "authorName": "mtion team",
    "tags": [
        "gaming",
        "trends",
        "2023"
    ],
    "url": "",
    "content": [{
        "sectionId": 1,
        "sectionTitle": "",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "If you haven’t been paying attention to the gaming industry now is the time to start.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "As we enter 2023 take some time to slow down (maybe even touch some grass) and admire how far the gaming industry has come in recent years. By<sup>[1]</sup> 2030 the gaming industry will be worth $470 billion USD and it doesn’t show any signs of slowing down. As the industry continues to grow and evolve, more and more people have begun to realize that there is more to our precious games than meets the eye. Video games have the power to impact, empower and educate communities around the world, and we think that’s pretty neat. The industry is growing and evolving at an unprecedented rate these days, which is why we’ve curated a list of trends to look out for in 2023. So buckle up and join us as we uncover what the world of gaming has in store for us this year. ",
            "paragraphAttr": [{
                "offset": 142,
                "subscript": "[1]",
                "url": "https://www.globaldata.com/media/thematic-research/mobile-gaming-represent-50-revenues-will-470-billion-gaming-industry-2030-says-globaldata/#:~:text=14%20Sep%2C%202022%20Mobile%20gaming,industry%20by%202030%2C%20says%20GlobalData&text=Mobile%20gaming%20is%20where%20the,gaming%20industry%20revenues%20in%202030."
            }]
        }
        ]
    },
    {
        "sectionId": 2,
        "sectionTitle": "The Metaverse in Gaming ",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Zuckerberg isn’t the only one exploring the possibilities of a metaverse, and the gamers of the world might actually be one step ahead of him. There have already been a few instances of a gaming metaverse. A notable example is The Sandbox, a virtual world where users can utilize the VoxEdit software to create 3D animated models that users can later sell or trade on the Sandbox marketplace. Users also have the option to create 3D games by using the visual scripting tools, and can do so without the need for any prior coding knowledge. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "While the Metaverse has yet to reach its full potential, the gaming community envisions that it will have a big impact on the industry. Around 52%<sup>[2]</sup> of US gamers believe that the metaverse will change the gaming industry, and<sup>[3]</sup> considering 97% of industry watchers see the gaming industry as the center of the metaverse, it seems as though the gaming industry and the metaverse are fairly intertwined. As complementary technology such as VR, AR, and 3D functionality develops further, the metaverse is anticipated to expand and flourish. To learn more about the future of AR and VR technology<sup>[4]</sup> check out our blog post “The Future of Streaming”. ",
            "paragraphAttr": [{
                "offset": 146,
                "subscript": "[2]",
                "url": "https://venturebeat.com/metaverse/52-of-u-s-gamers-believe-the-metaverse-will-change-the-game-industry/"
            },
            {
                "offset": 237,
                "subscript": "[3]",
                "url": "https://assets.ey.com/content/dam/ey-sites/ey-com/en_us/topics/tmt/ey-tmt-gaming-metaverse-report-final.pdf?download"
            },
            {
                "offset": 616,
                "subscript": "[4]",
                "url": "https://www.mtion.xyz/blog/post_3"
            }
            ]
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "Platforms such as mtion studios have begun to demonstrate some of the possibilities the metaverse would unlock within the world of streaming. Mtion studios has developed 3D clubhouses that creators can customize and stream from; the potential for viewer engagement and interaction would make this platform an amazing addition to the metaverse. ",
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 3,
        "sectionTitle": "Cloud Gaming",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Ah the wonders of technology, gone are the days of cleaning out cartridges and organizing tens of dozens of disks; with the help of the cloud we've moved on to greener pastures. Nostalgia aside, the cloud gaming industry has been growing at a lighting speed these last few years. In 2020 the global cloud gaming industry was worth $244<sup>[5]</sup> million, and it is projected<sup>[6]</sup> to be worth $21,954 million by 2030. Part of the reason cloud gaming has become so successful is the cost effective nature of the service. Users don’t have to purchase a physical game disk, and sometimes can do without a physical gaming console. Cloud based gaming is more reliable, consistent, and flexible, which are facets that the modern gamer has slowly become accustomed to. When all your games can be accessed via the cloud, you don’t have to worry about if the game you wish to purchase has sold out in stores, and whether or not you happen to have your console or physical game copy (and save file) with you. As video games continue to grow in popularity, and expand to reach new audiences, the simplicity of cloud gaming will ensure consistent and long-lasting industry growth. ",
            "paragraphAttr": [{
                "offset": 335,
                "subscript": "[5]",
                "url": "https://www.alliedmarketresearch.com/cloud-gaming-market-A07461"
            },
            {
                "offset": 378,
                "subscript": "[6]",
                "url": "https://www.alliedmarketresearch.com/cloud-gaming-market-A07461"
            }
            ]
        }]
    },
    {
        "sectionId": 4,
        "sectionTitle": "Mobile Gaming",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_1_1.png"
            ],
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "You got any games on your phone? No but actually do you? If you answer yes, then you are just one of the many candy crush players contributing to one of the largest segments in the gaming industry. As of 2022 there are over 2.69<sup>[7]</sup> billion mobile game players worldwide; for context, that is more than 30% of the world's entire population. And considering how many people in our day and age own a cellphone, that number isn’t all too surprising. For years it seemed like those who enjoyed mobile games were shunned and ignored within the gaming community, but the impact they have on the industry cannot be ignored any longer. Mobile gaming makes up<sup>[8]</sup> a whopping 57% of the industry revenue, which is more than both console and PC gaming combined. As for specific mobile gaming trends, hyper casual games continue to top the charts, with puzzle and arcade games trailing behind. It’s also interesting to look at who makes up the brunt of the mobile gaming user demographic. While you’d expect it to be kids or<sup>[9]</sup> the zoomers, it’s actually middle aged women; the powers of candy crush I suppose. But the demographic of mobile game users may see a shift in the upcoming years as more AAA mobile games hit the market. Games such as Genshin Impact are a great example of the success high quality games, that would otherwise only be available on PC or console, have the potential to experience on a mobile platform. Since its release in 2020, Genshin Impact has been downloaded over 142 times, and made over $3.3 billion in revenue. It’s a fair claim to say that they’ve helped pave the way for other more established game developers to release high quality games on mobile platforms.",
            "paragraphAttr": [{
                "offset": 228,
                "subscript": "[7]",
                "url": "https://www.blog.udonis.co/mobile-marketing/mobile-games/mobile-game-market-trends#:~:text=With%202021%20almost%20behind%20us,Store%20revenue%20share%20(66%25)."
            },
            {
                "offset": 660,
                "subscript": "[8]",
                "url": "https://www.globaldata.com/media/thematic-research/mobile-gaming-represent-50-revenues-will-470-billion-gaming-industry-2030-says-globaldata/#:~:text=14%20Sep%2C%202022%20Mobile%20gaming,industry%20by%202030%2C%20says%20GlobalData&text=Mobile%20gaming%20is%20where%20the,gaming%20industry%20revenues%20in%202030."
            },
            {
                "offset": 1032,
                "subscript": "[9]",
                "url": "https://www.aarki.com/insights/mobile-gaming-trends-and-challenges"
            }
            ]
        }
        ]
    },
    {
        "sectionId": 5,
        "sectionTitle": "Women in Gaming",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Historically the gaming industry has been viewed as a predominantly male industry, both in terms of game creation and gameplay. But, over the last several years this narrative has been changing as more and more women find a passion for video games. Considering women make up about half of the population, there is a ton of potential in successfully targeting this demographic. Studies show that<sup>[10]</sup> women make up approximately 48% of the gaming market, and 63% of the mobile gaming market. Women are also entering the streaming scene on platforms such as Twitch and Youtube; with streamers such as Pokimane, QTCinderella, and AriGamePlays, who have been experiencing massive growth and success. Unfortunately there is still a major discrepancy between the number of men and women within the industry, particularly among game designers and developers. But that’s not to say there isn’t any growth towards a more equitable<sup>[11]</sup> future; 38% of game developers are women, an increase from 2016 when it was only 27%. While there is still a ways to go in terms of creating spaces that are more welcoming and inclusive, we’re taking some steps in the right direction. ",
            "paragraphAttr": [{
                "offset": 394,
                "subscript": "[10]",
                "url": "https://www.transperfect.com/blog/women-in-gaming"
            },
            {
                "offset": 931,
                "subscript": "[11]",
                "url": "https://www.transperfect.com/blog/women-in-gaming"
            }
            ]
        }]
    },
    {
        "sectionId": 6,
        "sectionTitle": "Educational tool",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Here’s a simple question, would you rather play a video game or work on some math homework? Something tells me that a sheet of math problems (especially when you were a kid) was not your idea of a fun time. But math, and the many other school subjects that you may have found tedious and uninteresting, do in fact need to get done. Let’s go back to my original question, math or games, or what if I told you that you could combine the two? Utilizing games as an educational<sup>[12]</sup> tool exposes students to content that may otherwise be challenging and tiresome, in a fun and engaging manner. By making the learning process more fun for (especially younger) students, you are helping them discover the joys of learning. And if we can help the next generation of students learn how to enjoy their educational journey instead of dreading it, students will be more open to new opportunities and may even find a passion they otherwise would have avoided. Children are the future, and if we can peak their interest and foster an environment where they can enjoy the process of learning, who's to say what kind of innovation they’ll bring about down the line.",
            "paragraphAttr": [{
                "offset": 473,
                "subscript": "[12]",
                "url": "https://today.tamu.edu/2021/09/06/5-reasons-video-games-should-be-more-widely-used-in-school/"
            }]
        }]
    },
    {
        "sectionId": 7,
        "sectionTitle": "Expanding Globally",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "As the gaming industry expands, it’s no surprise that growth is being seen all over the world. Cloud gaming plays a role in this global expansion, mainly due to the affordability of the service, as mentioned previously. As games become more widely accessible, more people from around the world have more options that are significantly cheaper than they once previously were. One part of the world that has seen tremendous growth in regards to the popularity of the gaming industry would be Southeast Asia. Between 2020 and 2025 the expected compound<sup>[13]</sup> annual growth rate is 8.6% and there is already a huge market of about 270 million. In Southeast Asia total revenue was expected<sup>[14]</sup> to reach $82 billion USD in 2022, making up approximately 55% of the global market for video games. As the gaming industry continues to expand beyond borders, there’s no telling quite how large this industry will grow to in the next couple of decades.",
            "paragraphAttr": [{
                "offset": 549,
                "subscript": "[13]",
                "url": "https://nikopartners.com/southeast-asias-games-market-a-short-guide-to-one-of-the-fastest-growing-regions-for-the-games-industry/"
            },
            {
                "offset": 693,
                "subscript": "[14]",
                "url": "https://nikopartners.com/southeast-asias-games-market-a-short-guide-to-one-of-the-fastest-growing-regions-for-the-games-industry/"
            }
            ]
        }]
    }
    ]
},
{
    "id": news_data[1].slug,
    "text": "Viewer engagement is one of the hallmarks for streamer success..",
    "title": "11 Ways to Engage with Your Viewers While Streaming",
    "image": "/images/blog/post_2.jpg",
    "date": "3 Feb",
    "time": "5 min read",
    "subImages": [
        "/images/blog/gallery_2_1.jpg",
        "/images/blog/gallery_2_2.jpg"
    ],
    "authorImage": "/images/blog/author_large.jpg",
    "authorName": "mtion team",
    "tags": [
        "streaming",
        "tips",
        "engagement"
    ],
    "url": "",
    "content": [{
        "sectionId": 1,
        "sectionTitle": "",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Viewer engagement is one of the hallmarks for streamer success; the more community engagement you have, the more likely viewers are going to retain your content and keep coming back for more. It’s also just a great way for you to foster a sense of community and really get to know your viewers. We’ve curated a list of 11 ways for you to improve your viewer engagement while streaming, in the hopes that you build the community we know you can. ",
            "paragraphAttr": [

            ]
        }]
    },
    {
        "sectionId": 2,
        "sectionTitle": "1.  Be authentic",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "If there’s only one thing from this blog that you take away let it be this. To really send this point home, let me say it a little louder for the people in the back BE AUTHENTIC. People can sniff out disingenuous people (bullshit) from a mile away, and believe me it doesn’t smell all that pretty. I’m sure you’ve had the pleasure of interacting with someone who you could easily tell wasn’t really that interested in what you had to say. And that doesn’t feel great. When you inevitably talk to your chat and ask them questions, try to show that you actually care about their answers, or at the very least acknowledge them. If you treat viewer interaction as a chore, your audience will pick up on that and eventually stop contributing to your stream. ",
            "paragraphAttr": [

            ]
        }]
    },
    {
        "sectionId": 3,
        "sectionTitle": "2. Plan questions to ask your viewers",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "As previously mentioned, you asking your chat questions is pretty inevitable. Questions are a great way to engage with your viewers at the beginning and end, or when there are any lulls during your stream. As previously mentioned, you want to make sure you actually care about the answers your viewers provide you with, so asking the right questions is crucial. By planning out which questions you’re going to ask your viewers you can avoid the classic small-talk-panic- conversation-starters™ where you’d get stuck asking questions such as how was your day, what are you doing later, etc. You can ask more engaging questions that will start banter or discussion not only between you and the audience, but amongst the viewers themselves. Asking questions that don’t require a simple yes or no answer, are also probably the way to go. We’ve done you the pleasure of listing some example questions down below:",
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "What is the weirdest food combination you’ve ever created?",
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "If you could domesticate any animal, which one would you choose and why?",
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 4,
            "paragraphType": "text",
            "paragraphContent": "What game sparks the most nostalgia for you?",
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 5,
            "paragraphType": "text",
            "paragraphContent": "What is the best compliment you’ve ever received?",
            "paragraphAttr": [

            ]
        }
        ]
    },
    {
        "sectionId": 4,
        "sectionTitle": "3.  Address your viewers by their screen names ",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "I don’t know about you, but there is no better feeling than when one of my favorite creators replies to a comment I made, or says my name out loud on stream. Being noticed and acknowledged is the ultimate victory for the chronically online viewer. You don’t know what kind of day your audience members are having, and may be unaware of the effect you could have on said day. Even if you’re a small creator who doesn't think it’ll have the same effect as when big users shout people out, we’re fairly certain that no one would ever really turn down a little bit of attention. It seems like a super simple tip, but it has the potential to have a huge impact. And besides, everyone likes to feel special every now and then.",
            "paragraphAttr": [

            ]
        }]
    },
    {
        "sectionId": 5,
        "sectionTitle": "4. Small but mighty",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Everyone starts somewhere, and typically the start is slow. In the beginning of your streaming journey, having only a handful of viewers is a typical occurrence, but this isn’t an indicator of your potential for future success. What will set you apart from the other small streamers is how you choose to begin fostering your community, and engaging with the viewers you do have. In some ways small streamers have the upper hand, because you have the ability to really get to know your audience on a very personal level. Make the extra effort to remember details your viewers share about themselves and bring them up during your next stream. By taking the time to show that you genuinely care about your viewers, you are building a strong foundation for brand loyalty, helping you retain viewers in the future.",
            "paragraphAttr": [

            ]
        }]
    },
    {
        "sectionId": 6,
        "sectionTitle": "5. Engage with your viewers outside of your stream",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Even if you’re streaming for several hours a day, there are still plenty of hours left in the day. Staying connected with your audience throughout the day by using social media and whatnot helps you to fully flesh out a sense of community, and demonstrates to your users that you are invested in connecting with them. It also relates back to our previous point of being able to make your users feel special and valued within your community. Through engaging with viewers outside of the stream on social media you also have the potential to create inside jokes or update viewers on the goings on in your life. So, when you kickstart your stream and reference these exclusive bits of information, it will make your audience feel as though they’re privy to top secret information. ",
            "paragraphAttr": [

            ]
        }]
    },
    {
        "sectionId": 7,
        "sectionTitle": "6. Tease content happening later in the stream ",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "As frustrating click bait can be sometimes, it does have a habit of being rather effective. Of course you won’t be legitimately click-baiting your audience because you will be delivering on your promises, so don’t worry, you can sleep soundly at night. But by teasing maybe the mention of a merch drop, or a special event date, you can hopefully keep viewers watching the stream for a little bit longer. This may be one of the more shrewd tips on this list, so we don’t necessarily recommend you utilize this one on a consistent basis. But hey it’s a shark eat shark world out there, so do what you must to survive. ",
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "These next couple tips are more technical ways to better engage with your viewers during your stream.",
            "paragraphAttr": [

            ]
        }
        ]
    },
    {
        "sectionId": 8,
        "sectionTitle": "7. Use a stream deck, touch portal or micro management software",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "There are so many tools and softwares available to streamers that don’t just help simplify the streaming process, but can also be used to facilitate viewer interaction and engagement. @sunflowermag<sup>[1]</sup> made a super informative TikTok giving us an in depth look at her stream deck setup. She includes shortcuts that let her move from her starting soon, to game, to brb scene. She also has a folder that houses a bunch of different sounds she can use in stream, and a folder that houses a bunch of commands that she can use to better interact with the chat. Besides directly facilitating the engagement with viewers, these simplifications save you time that can otherwise be spent talking and interacting with your viewers, which is always a plus. ",
            "paragraphAttr": [{
                "offset": 197,
                "subscript": "[1]",
                "url": "https://vm.tiktok.com/ZMYRrDWWg/"
            }]
        }]
    },
    {
        "sectionId": 9,
        "sectionTitle": "8. Stream with mtion studios",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "When you’re first starting out you want to make sure you can stand out from the crowd. But a lot of the software you could use to customize aspects of your stream set-up probably cost a fair bit. If you want to stream from a customized 3D space, that’s quick, free and easy to set up, the mtion studios might be what’s missing from your stream. For streamers who are new to the world of streaming mtion makes it easy to immerse your viewers within a customized and interactive 3D space. Current mtion users claim that they use the software to create more immersive streams, better engage with viewers, and to stand out from the competition. One notable way mtion helps engage viewers through creating a starting soon sequence instead of simply having a starting soon count down or a still image. By having a super engaging sequence with lots of different scenes and 3D visuals to interact with, you set the tone for a great stream. To learn more about the value of 3D spaces in the world of streaming, check out our blog about the future<sup>[2]</sup> of streaming.",
            "paragraphAttr": [{
                "offset": 1037,
                "subscript": "[2]",
                "url": "https://www.mtion.xyz/blog/post_3"
            }]
        },
        {
            "paragraphicId": 2,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_2_1.png"
            ],
            "paragraphAttr": [

            ]
        }
        ]
    },
    {
        "sectionId": 10,
        "sectionTitle": "9.   Host a specialty stream ",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "If you want to mix up your regularly scheduled program, a speciality stream is a great way to go about doing that. Speciality streams can range anything from a charity stream, to a holiday special, or simply branching out from your regular content. These types of streams can expand your reach to new audiences and offer your regulars some variety to keep them engaged. Besides, mixing it up every now and then can be pretty fun. On top of changing the content of your stream, you could also decorate your streaming space to match the theme of the special. One super easy way of mixing things up is to utilize mtion studio and stream from one of their 3D spaces, just like Braethron<sup>[3]</sup> did for his christmas charity stream. Using one of these 3D “clubhouses'' is a great way to promote interaction with your viewers and really immerse them in your stream. If you ever find yourself in a lull, keeping things funky fresh is bound to keep your viewers’ attention.",
            "paragraphAttr": [{
                "offset": 682,
                "subscript": "[3]",
                "url": "https://www.twitch.tv/videos/1688877203?filter=all&sort=time"
            }]
        }]
    },
    {
        "sectionId": 11,
        "sectionTitle": "10. Utilize a moderator or a bot during your stream",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "When you’re deeply invested in a game that requires your full attention, the chat can oftentimes get pushed to the back burner in your mind. By having a moderator, you can have someone watching and engaging with the chat throughout your stream. Your mod can also monitor the chat with the intention of ensuring that the chat stays civilized, and that your community feels safe while engaging with your streams. You can also have your mod bring important or relevant discussion points to your attention so that you can multitask playing the game and interacting with your audience; truly the best of both worlds. Another simple way to get the same kind of effect would be to utilize different bots that can either monitor the chat by preventing spam and filtering responses, or automate certain commands. Whether you choose a mod or a bot, both options have the potential to save you time, which means more time to engage with your audience.",
            "paragraphAttr": [

            ]
        }]
    },
    {
        "sectionId": 12,
        "sectionTitle": "11. Make everyone feel welcome by promoting inclusivity and diversity",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "When you don’t feel welcome in a space, there’s a pretty good chance you will try to avoid that space; thank you captain obvious. This same ideology applies to your stream. If your stream, or even the chat, is filled with hateful, offensive, or malicious content, the demographic you will attract will inevitably be smaller. Quick maths. By promoting an environment of inclusivity and diversity, marginalized groups will feel safe being a part of your community, while discouraging those who want to spread hate or have the malicious intent to belittle others online. By simply creating a welcoming community, people will flock to bask in the good vibes you’ve facilitated. ",
            "paragraphAttr": [

            ]
        }]
    },
    {
        "sectionId": 13,
        "sectionTitle": "Final Thoughts",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Improving viewer engagement is a great way for you to build relationships with your audience and establish a feeling of community. Whether you utilize technology to optimize time spent during your stream, or simply put the effort into authentically interacting with your audience, viewer engagement is sure to increase overtime. And honestly, seeing the real life impact of your stream on your audience is an incredibly rewarding experience. ",
            "paragraphAttr": [

            ]
        }]
    }
    ]
},
{
    "id": news_data[2].slug,
    "text": "Whether or not you saw it as a benefit, or a cursed wish, over the pandemic...",
    "title": "The Future of Streaming",
    "image": "/images/blog/post_3.jpg",
    "date": "5 Feb",
    "time": "3 min read",
    "subImages": [
        "/images/blog/gallery_3_1.png",
        "/images/blog/gallery_3_2.png"
    ],
    "authorImage": "/images/blog/author_large.jpg",
    "authorName": "mtion team",
    "tags": ["streaming", "twitch", "mtion"],
    "url": "",
    "content": [{
        "sectionId": 1,
        "sectionTitle": "",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Whether or not you saw it as a benefit, or a cursed wish, over the pandemic it seemed as though we had an endless amount of time. While I’m sure some people used this time to maybe pick up a hobby (any knitters out there), many of us found ourselves simply looking for a distraction. And considering the sheer amount of content available at our disposal on twitch, it’s no wonder how many people flocked to that platform. According to Amazon, Twitch is frequented by over 31<sup>[1]</sup> million people per day, and<sup>[2]</sup> more than 720 million hours of content<sup>[3]</sup> were broadcasted by over 15 million gaming channels in 2020. The odds that you won’t find at least one streamer, or type of content, you enjoy watching is as unlikely as (funny haha thing that is unlikely to happen but make it gaming). During a time when people were also on the hunt for some form of social interaction or community, it’s unsurprising how many new streamers hit the scene. Twitch in particular has seen some tremendous<sup>[4]</sup> growth over the last few years; in 2023 twitch is anticipated to reach 1 billion audience members. Even after the lockdown regulations subsided, the streaming industry has maintained a steady follower base, which goes to show that the future of streaming is one to look out for.",
            "paragraphAttr": [{
                "offset": 474,
                "subscript": "[1]",
                "url": "https://newzoo.com/insights/articles/gamings-live-streaming-audience-will-hit-one-billion-next-year-1-4-billion-by-2025"
            },
            {
                "offset": 516,
                "subscript": "[2]",
                "url": "https://newzoo.com/insights/articles/gamings-live-streaming-audience-will-hit-one-billion-next-year-1-4-billion-by-2025"
            },
            {
                "offset": 569,
                "subscript": "[3]",
                "url": "https://newzoo.com/insights/articles/gamings-live-streaming-audience-will-hit-one-billion-next-year-1-4-billion-by-2025"
            },
            {
                "offset": 1019,
                "subscript": "[4]",
                "url": "https://golightstream.com/the-future-of-twitch-and-streaming-video-games/"
            }
            ]
        }]
    },
    {
        "sectionId": 2,
        "sectionTitle": "VTubers",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "A new type of streamer is hitting the scene and has been making headlines. In case you’ve been living under a rock, a VTuber or virtual Youtuber is a content creator or streamer who uses motion capture software to depict their facial expression and actions onto a virtual avatar. VTubers first came about in the mid 2010’s and have experienced a boom in popularity since. The global VTuber market earned approximately $2,804.7<sup>[5]</sup> million USD in 2022, and is projected<sup>[6]</sup> to earn $17,400 million by 2028. This new style of content creation offers individuals an immense amount of creative freedom, since they have the flexibility to present themselves online however they choose. Which means your dreams of becoming an anime girl are finally within reach. But in all seriousness, this sort of technology has made it possible for those who may have been unable to show their faces online for safety reasons, or simply personal preference, to join in the fun and become a part of the streaming community. ",
            "paragraphAttr": [{
                "offset": 426,
                "subscript": "[5]",
                "url": "https://www.marketwatch.com/press-release/vtuber-virtual-youtuber-market-size-and-growth-segments-2022-qualitative-research-by-leading-manufacturers-recent-developments-statistics-and-forecast-to-2028-2022-12-01#:~:text=The%20global%20Vtuber%20(Virtual%20YouTuber)%20market%20is%20projected%20to%20reach,%2C%20774%2C%20inc%2C%20etc."
            },
            {
                "offset": 478,
                "subscript": "[6]",
                "url": "https://www.marketwatch.com/press-release/vtuber-virtual-youtuber-market-size-and-growth-segments-2022-qualitative-research-by-leading-manufacturers-recent-developments-statistics-and-forecast-to-2028-2022-12-01#:~:text=The%20global%20Vtuber%20(Virtual%20YouTuber)%20market%20is%20projected%20to%20reach,%2C%20774%2C%20inc%2C%20etc."
            }
            ]
        },
        {
            "paragraphicId": 2,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_3_1.png",
            ],
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "The VTuber lifestyle has become so appealing that even AI wants to get involved. In recent weeks AI chat bots such as ChatGBT have been the talk of the town, with their capacity to write jokes, essays and even solve code, but it turns out that these bots can also play rhythm games. Introducing Neuro-Sama, the storied AI VTuber who has recently gotten into a bit of trouble with the twitch terms and service violations. Neuro-Sama can play a few games, such as osu! And minecraft, while also interacting with the chat and her viewers. Neuro-sama has gained a slight reputation for her sense of humor, as she often makes jokes about the fact that she is artificial intelligence, but does so in a way that makes her sound human. It’s very paradoxical, but considering she has over 50,000 followers on twitch, it must be pretty entertaining. ",
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 4,
            "paragraphType": "text",
            "paragraphContent": "One of the most exciting elements of being a VTuber may just be the creative freedom involved in your character customization. In general the possibilities for customization are one of the initial factors that draw people to explore this sort of content creation. Many VTubers are taking interest in platforms such as Mtion Interactive, that allow for additional creative expression and customization. Mtion Interactive creates 3D clubhouses that users can customize and stream from. These virtual spaces facilitate more viewer interaction and have features such as multiple settings and camera angles, that keep viewers engaged throughout the stream. As content creators continue to innovate and add novelty to their streams, the more possibilities there are for both personal and industry growth.",
            "paragraphAttr": [

            ]
        }
        ]
    },
    {
        "sectionId": 3,
        "sectionTitle": "Virtual and Augmented Reality",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "As enthusiasm around virtual and augmented reality continues to grow, it’s no surprise to see the bounds we’ve made towards advancing this technology. In 2023 the industry will be tackling and likely (hopefully) make some bounds towards developing more affordable systems, and introducing inside out tracking and offering wireless headset alternatives. Even in the streaming space we are beginning to see more and more creators whose main focus is playing VR games or even making content solely about how to stream VR programs. AtomBombBody<sup>[7]</sup> is a streamer who creates educational content centered around teaching others how to stream VR games, while also indulging in such games herself. With help of awesome creators such as AtomBombBody, who have a wealth of knowledge to share about the ins and outs of VR streaming, more streamers will have the ability to create high quality content with VR technology. ",
            "paragraphAttr": [{
                "offset": 540,
                "subscript": "[7]",
                "url": "https://www.youtube.com/@AtomBombBody"
            }]
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "As virtual reality technology becomes more accessible and more people start playing VR games, more people will inevitably stream their gameplay. As the interest in VR games grows, more VR games will be designed and produced, which will also promote the streaming of their gameplay. If there are limited VR games available to play, people may be hesitant to stream that content since they won’t feel as though it’s original. We’ll also even be able to watch streams through a VR headset, and be truly immersed in the vicarious gameplay. This could be especially popular for first-person games, where the player's point of view is the main focus. ",
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "Augmented reality is also expected to become more popular in the world of streaming. AR allows for the overlay of digital information and graphics on the real world, which can be used to enhance the streaming experience. This could be used to provide additional information about the game, such as character stats or map information, or to create interactive elements that viewers can interact with. AR can also be used to create interactive elements that viewers can interact with, such as virtual characters or objects that appear in the stream. This can create a more engaging and immersive experience for viewers, and also provide new opportunities for monetization, such as virtual goods or in-stream advertising. Additionally AR can create a more interactive experience between streamers and their viewers. For example, a streamer could use AR to show their location on a map, or to allow viewers to control certain aspects of the stream, such as changing the camera angle or lighting. Finally, as AR technology becomes more advanced, it will be possible to stream live AR content on mobile devices, making it more accessible to a wider audience, as they won't need a special hardware to experience the AR content.",
            "paragraphAttr": [

            ]
        }
        ]
    },
    {
        "sectionId": 4,
        "sectionTitle": "IRL streamer and just chatting popularity",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_3_2.png"
            ],
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "What was once a gaming sanctuary has now become an amalgamation of different content genres, with the “just chatting” category becoming increasingly popular. People are realizing that their personalities sell, and that interacting with their viewers and talking about who knows what, makes for a great time. IRL streamers often share a more personal side to their lives, and makes viewers feel legitimately connected to these streamers; which is a great way to build a community. And in an era when people are craving authentic connections and interactions, IRL streamers can provide just that. ",
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "IRL streamers have also managed to tap into a demographic that otherwise wouldn’t be all that interested in historical streaming content. Some people just have no interest in watching someone else’s gameplay, but would love to hear their day. As IRL streamers gain popularity, more and more creators are learning that their non-gameplay content has the potential to be successful. Visual artists, music producers, chefs, the list goes on. The future of streaming depends on a wide variety of content, and luckily for us there’s no shortage of streamers willing to create.",
            "paragraphAttr": [

            ]
        }
        ]
    },
    {
        "sectionId": 5,
        "sectionTitle": "Branching out to other platforms",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "The internet loves to recycle content, take instagram reels for example; simply TikTok but a few weeks late. And it’s inevitable that everything ends up on twitter. But this content echo is actually a great way to grow and establish a platform that stretches beyond your content’s original birthplace. Streamers have already started to utilize TikTok as a way to garner attention for their accounts by posting clips and highlights from their stream. As more and more social media platforms rise in popularity, there will soon be an endless number of places where you can promote your content and brand. Cross-platform promotion will help streamers grow in popularity, and perhaps allow them to advance their careers outside of streaming. ",
            "paragraphAttr": [

            ]
        }]
    },
    {
        "sectionId": 6,
        "sectionTitle": "Utilizing virtual 3D spaces",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "What used to be a stream is now becoming a space.",
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 2,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_3_3.png"
            ],
            "paragraphAttr": [

            ]
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "The future of streaming lies in the emulation of the real world, as people crave more and more interaction and engagement with the creators they devote their time to watching. mtion studio provides customizable and virtual 3D spaces that facilitate the potential for these interactions. These virtual 3D spaces, or Clubhouses, are online environments that streamers can customize and use as their own interactive 3D environment where they can stream their content to their community. One of the key themes we’ve noticed within the tech world is the fact that people want to create authentic experiences that bridge the virtual and the real. At motion studio, our vision is to provide a virtual live streaming experience that is more immersive, authentic, and entertaining than anything possible in physical reality. We envision the world of streaming to seamlessly combine the virtual with the real; where we’re not just facilitating a stream but shaping a space where people can interact and create together.  ",
            "paragraphAttr": [

            ]
        }
        ]
    }
    ]
},
{
    "id": news_data[3].slug,
    "text": news_data[3].text,
    "title": news_data[3].title,
    "image": news_data[3].image,
    "date": news_data[3].date,
    "time": news_data[3].time,
    "subImages": [
        "/images/blog/gallery_2_1.jpg",
        "/images/blog/gallery_2_2.jpg"
    ],
    "authorImage": "/images/blog/author_large.jpg",
    "authorName": "mtion team",
    "tags": [
        "streaming",
        "showcase",
        "podcast"
    ],
    "url": "https://youtu.be/1QRHO26xZ6E",
    "content": [{
        "sectionId": 1,
        "sectionTitle": "Future of Streaming Podcast #1: Redefining Creativity in Streaming as a Vtuber",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "“It's more than a tool to me.” - Guest Tateshi",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "Watch the full video <a href=\"https://youtu.be/1QRHO26xZ6E\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">here!</a> ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 4,
            "paragraphType": "text",
            "paragraphContent": "Welcome to our very first episode of the future of streaming podcast! We're excited to have Tateshi, a highly creative and crafty variety VTuber, as our guest. In this episode, Tateshi shares his experience using mtion studio, and offers valuable tips and tricks he's learned along the way. You'll also discover how Tateshi uses mtion to boost viewer engagement by redeeming channel points and featuring his viewers. Tune in to learn how Tateshi is pushing the limits and revolutionizing the streaming experience with mtion studio.",
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 2,
        "sectionTitle": "In this episode, we delve into the following topics with our guest Tateshi:",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "bullet",
            "paragraphContent": "How Tateshi incorporates mtion studio into his streaming setup",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "bullet",
            "paragraphContent": "The ways in which mtion studio helps Tateshi level up his stream with illusions and forced perspectives",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "bullet",
            "paragraphContent": "Discovering Easter eggs and inside jokes hidden around Tateshi's clubhouse",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 4,
            "paragraphType": "bullet",
            "paragraphContent": "Tateshi's unique approach to expressing themselves and personalizing their stream with mtion studio",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 5,
            "paragraphType": "bullet",
            "paragraphContent": "Effective techniques Tateshi uses to increase audience engagement during their stream using mtion studio.",
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 3,
        "sectionTitle": "Highlights",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "bullet",
            "paragraphContent": "Relaxing in the hot tub at Tateshi's clubhouse [00:03:37]",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "bullet",
            "paragraphContent": "Users keeping things interesting by redeeming channel points and switching the camera [00:12:35]",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "bullet",
            "paragraphContent": "Tateshi's favorite mtion clubhouses [00:13:38]",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 4,
            "paragraphType": "bullet",
            "paragraphContent": "There’s a space Eggo? [00:16:58]",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 5,
            "paragraphType": "bullet",
            "paragraphContent": "Tateshi's love for mtion and the freedom it provides for self-expression [00:20:09]",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 6,
            "paragraphType": "bullet",
            "paragraphContent": "The hack of using bots to set up camera sequences [00:21:32]",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 7,
            "paragraphType": "bullet",
            "paragraphContent": "The significance of mtion studio as more than just a tool [00:22:43]",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 8,
            "paragraphType": "bullet",
            "paragraphContent": "Why VTubers should incorporate mtion into their streaming toolkit [00:27:03]",
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 4,
        "sectionTitle": "About our Guest",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Our guest Tateshi_VR is a variety VTuber who shares their gaming experiences on both Twitch and YouTube. Tateshi's streams are full of engaging and hilarious moments, especially when playing retro and 90s-inspired games. We highly recommend checking them out! Tune in to their streams on Tuesday, Thursday, Friday, and Saturday, and follow them on Twitch and Twitter using the links below:",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "Twitch: <a href=\"https://www.twitch.tv/tateshi_vr\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">https://www.twitch.tv/tateshi_vr</a> ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "Twitter: <a href=\"https://twitter.com/Tateshi_vr\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">https://twitter.com/Tateshi_vr</a> ",
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 5,
        "sectionTitle": "Interview Transcript ",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "* The transcript has been edited slightly for the sake of clarity",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> We have our main feature guest here Tateshi. Tatashi. Tell us a bit about yourself, my friend.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> What is up internet? I am Tateshi and I am a variety VTuber on Twitch. I do a little bit of YouTube on the side. I started off doing VR content and then we slowly branched out into doing retro old school games to more modern games. I have a wacky, fun, chill vibe type of a stream. We went from like a lot of onscreen gags to doing a lot of in-house gags, so to speak, when it comes to using mtion.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 4,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> How long Have you been streaming for? And what is mtion able to incorporate in this content that you typically stream? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 5,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> I've been streaming on and off for like 10 years. The best way to describe it is I was there when Twitch was Justin TV and Amazon didn't own Twitch. That being said, I started doing VTubing, I wanna say 2020 or 2021. I started off with the generic VTuber on the screen with just the full screen gaming. Over time I put a chair in, I put a desk with a fish tank and then the last big one we had was a desktop display. It looked like my camera feed was a webcam. Now with the new set, I could basically sit here, have a just chatting screen and then if I wanted to I could just pan over to the big giant TV over there where we could just game at the bar. We have Marky Mark, Johnny five, Carl does a little bit of karaoke. We have more people that are around. We have um, Hatsune Miku and the list goes on. There's Easter eggs upon Easter eggs just chilling here that all have a redeemable channel point that people enjoy. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 6,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> That's the one of the things that I really like with mtion as well is that it gives, especially VTubing, just the ability to immerse your audience into a more realistic experience with the characters and backgrounds that you give them. It's kind of cool being able to take things and jokes and inside jokes of that nature and being able to put them into the spaces where you can continue to branch out and build on your content.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 7,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> Yeah, I like that I'm able to express myself a lot more through mtion and I like how I'm able to set up different cameras for different events. And if I want to have a just chatting section, I don't have to switch to another screen on my OBS, I can just press the camera pan right over to them, and we're good to go. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 8,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> You mentioned the hot tub upstairs. Can we carry this conversation up in the hot tub? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 9,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> Yeah. So I have this nice little hot tub scene and we have our sub-wall, and when people subscribe, I add people to the wall. Some people don't want to go in the hot tub. Well, all right, I have another spot. Would you like to be in my fish tank? Like so we have like a nice little fish tank over here with everybody in it. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 10,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> I love that. Tell me, how did you first discover mtion and what made you want to use it for your streams?",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 11,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> Back in that time? There wasn't TikTok or Twitter for mtion. So, at the time, I was doing VR chat type streams where I was a 3D model. So being able to work with a 3D space seemed right up my alley... And then I was like, hey, what if I started doing things that we can't do yet inside mtion? That's what I started working with doing channel points for certain objects. We don't have a skybox in mtion, but I decided to make a cheap one and it's been really interesting. What I can get away with with just parading minor illusions or tricks to trick my audience. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 12,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> Yeah. And it's quite an interesting kind of illusion that you can create with it depending on the ideas that you have. I mean, just the other day I was putting together a video while I was using mtion and was able to just upload a picture and make it almost look like a 3D asset. Um, how long have you been using mtion Studio in your content? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 13,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> For At least over six months or so. I know I used one of the pre-build clubhouses for a little bit and then we started moving into this kind of Space Shack. I think we've been here at this set for about three months or so. I'm finding ways to get more of my show done in mtion, instead of just doing the generic, let me just put the desktop game on and then put me in the corner and call it a day. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 14,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> Before using mtion Studio, what did your streaming set up look like and what were some of the challenges or issues that you faced before you found mtion? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 15,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> When I started VTubing my first model I had sunglasses, a baseball cap, and it was just me. And then over time we got Kyle, which is basically bikubot, and it just runs a few commands on the side, and then it talks to the audience. We went from having just me and them on screen, and then we went to our second set, which was Neo Tokyo City that we were working with for a while. When we got to mtion, I made the mental decision to go, okay, we are going to start from the beginning. We had an ending ceremony for the original set we were at at that time. And we moved over to the next one and it took some time, as you can clearly tell, like there are some things in here that are just PNGs and JPEGs and all that. I would really like to have more 3D items, so I'm hunting down or trying to find ways to create these 3D items and bring them in because even though the posters look great, this took me a while to find and get into mtion. I am not good at 3D design but I've gotten by pretty far doing VTubing stuff. But being able to go from the pre-made clubhouses and then finally start getting my hands dirty with really getting into how this program works. I've been asking myself, what can this program not do that I haven't already tried? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 16,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> Now that you're using mtion Studio, how have you integrated it into your streaming setup? And can you describe your current setup and how mtion now fits into it? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 17,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> So I have like two stream decks. I have a stream deck plus and a stream deck regular. The regular one has all of my camera functions. I like that it's very easy to switch between cameras, because then I'm able to execute really cool effects. I have a delay for like 10 seconds in between and keep panning between them over time so everybody can listen to music, and see that I'm working on stuff still in the background. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 18,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> What mtion clubhouses have you played around with so far and which ones are your Favorite? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 19,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> The only one I used for the longest time was the Neo Tokyo one, the very first one. I liked the aesthetic and that was what I was coming from with my 2D set. I had my BRB screen on one of the billboards and it would pan out of the apartment and go right to it, and then the sub wall we had it on top of a building. I wanted to use the Christmas one, but I ran out of time and the Spaceship one I really do enjoy. I remember the nightclub, the nice studio apartment, and the cozy library coffee shop which I tried out, and found it pretty chill. I wouldn't mind doing like a just-chatting there. I remember the Y2K one that was a really good one. Another thing I do really enjoy with mtion is you can do these like really cool camera effects in these clubhouses.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 20,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> I am such a sucker for good transitions and stuff of that nature; being able to move from certain cameras and being able to do that on a timer. You can start to create a loop, it'll be less button pressing, and then you'll have a bit more control in terms of prop management and things you might be moving, including your avatar. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 21,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> For me, I always like to think about things I could do with my set. One major thing I thought of was, what if I could do like a spiral, kind of like pan out with the camera? What if it's like, if I had three cameras set up and they're all set up in different X, Y, and Z axes.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 22,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> This clubhouse you're currently in, I'm gonna imagine that this is clearly your favorite one. Can you walk us through just how you have a bit more of your clubhouse set up? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 23,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> Let's see, here I have my fish tank. It's a running thing for my community. We're a sushi gang and we have a fish theme, so a couple of my community members requested to be in the fish tank. We do have a hot tub here. We have a pirate ship in space, and we're trying to put some enemies on that Ship.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 24,
            "paragraphType": "text",
            "paragraphContent": "Then we have this nice kind of cozy bar here and I have a BRB screen set up and of course I have an art wall back there. When it's time to end it for the night, I can come up here where my old schedule is, and tell everyone what's going on next week, and we cut away to the credits.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 25,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> And then you're just using a basic browser source, I imagine. So tell me, what are some of the things that you like most about streaming with mtion studio?",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 26,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> I feel like it's a great way to express myself, a lot of people I feel don't get to do that in their stream. They'll pay for their starting screen and their gaming scenes and all that; they'll have that all as a package. Here I could start the stream and then somebody will see he's just got like a regular video playing in the beginning. And then you just see it pan and we're like, oh what is going on here? Why is there Carl Wheezer over here? What is going on? And then we'll pan over to the game screen and it will look like somebody just playing games on Twitch. And they notice that it's not just this 2D cutout type of set and they see that it's really involved and interactive.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 27,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> I saw the crazy stuff that you're hacking out in mtion. Can you tell us about these interactive features that you, yourself have been implementing? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 28,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> A lot of the things that I've been doing behind the scenes with hacking has been, what can I do that hasn't been done already in mtion. We have generic hot key buttons for cameras and a stream deck to do panning. What if we can program a bot to actually trigger events? Right now we don't have that. But one way I’ve learned to work around this has been by setting up cameras and then telling a bot to press these buttons to trigger a random sound, and then trigger another camera. It's more than a tool to me. It's a really cool program and I think some people just turn it on and sit in the space. Whereas I wonder what I could put in here to make my stream even more unique. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 29,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> You put a great label on that because it is more than a tool. It's an entire scene, an entire set, an entire area where you can set up such a variety of props and have these more on the spot type moments or extra kinds of effects, on top of adding extra transitions and added effects and features. I've been doing a lot of video content with mtion, and just the extra layers that I can add from transitioning from one scene to another, honestly, the sky's the limit in terms of your creative ideas and what you can incorporate as well. So it's cool when you get to see like other people and their creative ideas being brought to life. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 30,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> And that's the other thing too, if you are not skilled in 3D design, there’re the pre-made clubhouses and they have a huge library of assets you can pull from to start making something that you can express yourself with. And I've done that for a while, being able to really get my hands dirty and start doing my own stuff has been a quest for me.But you don’t have to make all my own stuff. I recommend trying out some clubhouses and seeing what you can do with what mtion has. I still love going to the Neo Tokyo one that I have still, I still have it saved on the computer. I'll click on it once in a while to test out stuff and it's a really nice starting point before you dive all in. Start small and then work your way up to something. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 31,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> It's as easy as being able to load up a completely new clubhouse, saving that, and then finding a previous one and loading that one up. And having hot keys set up for that specific clubhouse as well, which is a great hack with the stream deck.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 32,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> Yeah, like one of the things that I enjoy is their multi action switcher. I could program Stream Deck to a specific camera and then cut to it, delay for a second and then jump to another camera. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 33,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> What are some other things you would like to say to streamers who haven't tried mtion studio yet? What other things could you suggest to them and features that you like and why do you think it'd be worth it for them to explore? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 34,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> VTubers I highly recommend, I've said this before but, this is like the next evolution in the VTubing space. It's not just a generic, somebody drew the background kinda setup. I'm looking forward to like the next two years with mtion. A lot more people are gonna know about it and they're going to be making their streams even more unique  And it's not just somebody sitting in playing a game, people are doing interviews or just having a couch co-op type stream going on. And it's not just the game, you see them just having a conversation sitting on the couch with the camera cutting back and forth between the two. Even with people that use webcams in green screens, they're going to find ways of creating really unique sets that kind of help them stick out more in the environment. When it comes to trying something in mtion don't be afraid to try it. You don't have to pay an artist to make a 3D set for you. You can use a lot of the pre-built clubhouses and change the set around so that it’s unique; you are the content first and foremost. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 35,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> Are there any tips and tricks that you'd recommend even just for beginners who haven't started or are even considering getting started? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 36,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> Start small like I did where we used one of mtion studio’s pre-build clubhouse and then I added stuff to that. When it gets to the point where you want to be able to have your own space, then look into it and then take your time. Do a space reveal and go all out on revealing this new space because it's gonna be your place for quite some time. I've gone through like five models in a span of two years. We're gonna change this place out soon and I'm gonna do a massive reveal on it. It's gonna be a lot bigger and have a lot more stuff in there for people to interact with, but only time will tell. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 37,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> Yeah, I think that's a great suggestion as well. Starting small is also the most realistic since a lot of people don't realize that they can work within the means of what they have already. Being able to stream off your console, reading chat off your cell phone and then if you already have a basic computer set up, there's a lot of things that you can do to really up the quality using affordable and very cost effective ways, that also don't take up too much hardware space. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 38,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> You also don't have to worry about OBS at all. It literally is just a camera on OBS. So you could set up a few things on OBS and never have to touch it besides stream and record. Most of your stuff can be done inside of mtion. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 39,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> Yep, 100%. This is where it wraps up all the questions that I have for you Tateshi. You've done an awesome job answering my questions and I very much appreciate you taking time out of your day to be able to join us today. You had a lot of great answers that I'm sure anyone who will be looking into mtion will find helpful. Because as the product starts to develop more and as more people get involved people are going to be looking for advice on how to get started. So Tateshi, where can we find you? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 40,
            "paragraphType": "text",
            "paragraphContent": "<b>Tateshi:</b> Of course, Twitch is the big one. I always stream Tuesday, Thursday, Friday, and Saturday. Tuesdays are usually the retro days and Mondays are usually special content for YouTube. But our big streams are Tuesday and Saturday. Fridays are usually a chill kind of a day, but you could find me at https://www.twitch.tv/tateshi_vr. We used to do more VR stuff,  it's just a little bit more complicated on stream. So I moved that to the YouTube channel, which is the same thing to Tateshi_VR and then I have Twitter, same thing again, Tateshi_VR. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 41,
            "paragraphType": "text",
            "paragraphContent": "<b>FakeUni:</b> Again, we really appreciate you taking the time to come talk with us and share your experience with us. And if you guys want to see more of Tatesh’s content, you'll be able to check it in the description down below. And as far as that goes, thanks for joining us today and we'll see you guys in the next one!",
            "paragraphAttr": []
        }
        ]
    }
    ]
},
{
    "id": news_data[4].slug,
    "text": news_data[4].text,
    "title": news_data[4].title,
    "image": news_data[4].image,
    "date": news_data[4].date,
    "time": news_data[4].time,
    "subImages": [
        "/images/blog/gallery_2_1.jpg",
        "/images/blog/gallery_2_2.jpg"
    ],
    "authorImage": "/images/blog/author_large.jpg",
    "authorName": "mtion team",
    "tags": [
        "press release",
        "announcement",
        "top startup"
    ],
    "content": [{
        "sectionId": 1,
        "sectionTitle": "Mtion interactive Ranked as the Top Startup in Ontario Canada by Canada Ventures",
        "sectionContent": [{
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "PRESS RELEASE",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "Kitchener, ON - March 29th 2023 - mtion interactive inc,  a gaming-tech startup specializes in providing personal social MMO experiences that help content creators build their brand, has been named top startup in Ontario, Canada by Canada Ventures. The company was recognized for its innovative approach in disrupting the streaming and gaming space.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 4,
            "paragraphType": "text",
            "paragraphContent": "Canada Ventures is a leading publication that focuses on highlighting the best startups and entrepreneurs in Canada. The publication has been tracking the progress of startups in Ontario, and recently released a list of the top 15 innovative social startups in the province. mtion interactive was ranked as a top startup on this list.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 5,
            "paragraphType": "text",
            "paragraphContent": "\"We are thrilled to receive this recognition from Canada Ventures,\" said Jeremy, CEO of mtion interactive. \"It is a testament to the hard work, innovation, and creativity of our team in developing a product that is loved by the creator community.\"",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 6,
            "paragraphType": "text",
            "paragraphContent": "mtion interactive has quickly become a key player in the videogame live streaming space, offering unique ways for content creators to build their brand and engage with their audience through virtualized spaces. The company's success is a reflection of its commitment to building amazing products for all gamers, streamers, and content creators.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 7,
            "paragraphType": "text",
            "paragraphContent": "This recognition by Canada Ventures is a significant milestone for mtion interactive and demonstrates the company's potential to continue its growth trajectory. The company looks forward to further establishing itself as a leader in the gaming and streaming space and expanding its reach in the Canadian market.",
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 2,
        "sectionTitle": "About mtion interactive",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "mtion interactive is building the social MMO platform for live streamers and their fans. Our tools make it easy for anyone to create virtual worlds that can be used to bridge reality with virtuality, letting anyone create, build, publish and livestream from virtual environments shared with friends and fans. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "The startup was founded by <a href=\"https://www.jjhartmann.org\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">Jeremy Hartmann</a>, a Ph.D. graduate from the University of Waterloo with over <a href=\"https://scholar.google.com/citations?hl=en&user=MPCI_sgAAAAJ&view_op=list_works\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">10 publications</a> in the space of human-computer interaction and extended reality. He has worked with researchers from Meta Reality Labs, Microsoft Research, and Adobe Research. mtion interactive recently graduated from NBC Universal Lift Labs Accelerator powered by Techstars in late 2022. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "Read the full announcement here: <a href=\"https://canadaventure.news/15-innovative-social-startups-in-ontario-shaking-up-the-industry/\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">https://canadaventure.news/15-innovative-social-startups-in-ontario-shaking-up-the-industry/\r</a>",
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 3,
        "sectionTitle": "Contact:",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Lynn Yang <br> Public Relations <br> mtion interactive inc. <br> <a href=\"mailto:marketing@mtion.xyz\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\"> marketing@mtion.xyz </a>",
            "paragraphAttr": []
        }]
    }
    ]
},
{
    "id": news_data[5].slug,
    "text": news_data[5].text,
    "title": news_data[5].title,
    "image": news_data[5].image,
    "date": news_data[5].date,
    "time": news_data[5].time,
    "url": "https://youtu.be/Y-0rdMn9KoE",
    "subImages": [
        "/images/blog/gallery_2_1.jpg",
        "/images/blog/gallery_2_2.jpg"
    ],
    "authorImage": "/images/blog/author_large.jpg",
    "authorName": "mtion team",
    "tags": [
        "streaming",
        "tips",
        "mtion studio"
    ],
    "content": [{
        "sectionId": 1,
        "sectionTitle": "10 Tips on mtion studio",
        "sectionContent": [{
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "When using mtion studio the only limit is your imagination. And with so many possibilities, the hardest choice you have to make is deciding where you want to start! We’ve created a guide of some tips and tricks that we think will be able to help you get started and inspire you to create some truly unique 3D streaming spaces. And do you want to know the best part? We’ve been inspired by you! Over the last few months the mtion team has been watching our endlessly creative community build some truly amazing spaces, and it’s been so cool to see! We hope you take some inspiration from our wonderful community, and follow their lead by creating some spaces that are uniquely yours. ",
            "paragraphAttr": []
        }]
    },
    {
        "sectionId": 2,
        "sectionTitle": "Navigating your Space with Ease",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "There are a few ways you can satisfy your inner need for speed while using mtion. A simple mechanic to go zooming about is to use the shift key when using the WASD(QE) keys to move around. Another way is to use the roller ball on your mouse to get around the space faster. But sometimes don’t you think life would be so much easier if you could just teleport? A protrip for navigating especially large mtion clubhouses is to place an object in any space you want to quickly come back to later (labeling your assets is also probably a helpful practice to put into action). By simply finding your asset in the scene objects sidebar, you can click f or the viewport button on the right side control panel, to be instantly transported to that asset.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_1.png"
            ],
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 3,
        "sectionTitle": "Optimizing mtion during your stream",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Because mtion is rendering a 3D environment in real time, think of mtion as an additional game your system is running. When you start streaming it is likely that you will have several softwares open, which could be GPU / CPU intensive and cause your stream to lag. One way to prevent this is to minimize mtion studio when you go live. When mtion is minimized it will disappear from the dock and end up in a system tray, saving 30-40% of mtion’s GPU usage. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "Also, there are shortcuts you can use to change graphic quality level in further optimize the app depending on your set up (RSHIT + RCTRL + [1-6])",
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 4,
        "sectionTitle": "Making Camera Transitions Easy with Stream Deck or macro management program such as Touch Portal",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "<a href=\"https://www.elgato.com/en/stream-deck-mk2\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">Stream Deck</a>",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "Changing camera angles in mtion can be easily done with just a click of a button. But what if that button was unavailable? Pure and utter chaos? Nope, luckily for you we’ve thought ahead and your stream will be able to continue even if you minimize mtion to save some GPU power. You always have the option of using shortcut keys but there’s an easier way. Since mtion integrates seamlessly with stream deck, you can easily set up a new profile for each of your clubhouses, and change camera angles with ease. Simply click on the mtion element in your stream deck menu and drag change camera into one of the boxes, it’s as simple as that!",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 7,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_2.png"
            ],
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "How this works with mtion: ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 5,
            "paragraphType": "text",
            "paragraphContent": "<a href=\"https://www.touch-portal.com/\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">Touch Portal</a> ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 6,
            "paragraphType": "text",
            "paragraphContent": "Another great macro management software that you can use to simplify your streaming process is touch portal. Touch portal can be integrated with a multitude of softwares such as twitch, OBS, and of course mtion studio. Touch portal is an application and not a physical product like the stream deck, but they work in similar ways. You can set up a \"short cut\" in the camera control panel in mtion studio, and then link the shortcut to touch portal to make it easier to change between camera transitions. Managing your customized streaming space has never been easier since you have all the power right at your fingertips.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 4,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_3.png",
            ],
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 5,
        "sectionTitle": "There’s this thing called “diegesis”",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "I bet you’re wondering “if I embed my input sources in a mtion clubhouse, won’t they look out of place?”. Excellent question and we’re so glad you asked! There is a magical setting called diegesis and it helps give your inputs a more immersive look by making your input object adapt to the environment's lighting! This setting is very useful for object types such as VTuber avatars and images; diegesis will make them look like actual objects in the space and add that fine touch of immersion.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "You can find this function by going into the input object’s control panel, under settings, you can turn “diegesis” on and off. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "Here are a couple before and after shots! See how much different it made!",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_4.png"
            ],
            "paragraphAttr": []
        },
        {
            "paragraphicId": 4,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_5.png"
            ],
            "paragraphAttr": []
        }

        ]
    },
    {
        "sectionId": 6,
        "sectionTitle": "Overlays",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Just because your mtion studios space is already decked out with a number of customizable assets and video captures, this doesn't mean you can’t still use overlays during your streams. Frames, on screen text, and other graphics are a great way to give your stream an air of professionalism, and besides they just look neat!  ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_6.png"
            ],
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "Check out <a href=\"https://www.twitch.tv/marcecatfish/\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">Marce Catfish’s</a> mtion space, she brought her chat onto the laptop screen by embedding her twitch chat overlay:",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_7.png"
            ],
            "paragraphAttr": []
        },
        ]
    },
    {
        "sectionId": 7,
        "sectionTitle": "Content placement in the 3D space to boost your branding and showcase your personality",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Something you may or may not have considered is the inclusion of your branded content in your space. Just as movies and tv shows include product placement in their content, you can do the same thing within your virtual space. Embedding  branded content, product, or even just your own collections of streaming assets, fan art, or images in your space is an easy way to fully embrace your personality on streams using mtion space. You could simply place a poster or get even more creative and design a virtual asset that is a replica of your branded product. The possibilities for subtle showcasing or immersive impressions are endless.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "<a href=\"https://www.twitch.tv/braethorn\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">Braethorn</a> placed images of his branding as building sign on the roof of his mtion clubhouse:",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_8.png"
            ],
            "paragraphAttr": []
        },
        {
            "paragraphicId": 4,
            "paragraphType": "text",
            "paragraphContent": "He also placed his “LGN” (Let’s Go Nerd) sign on his PC 3D model to bring more of his own branding and personally into the setup.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 5,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_9.png"
            ],
            "paragraphAttr": []
        },
        {
            "paragraphicId": 6,
            "paragraphType": "text",
            "paragraphContent": "<a href=\"https://www.twitch.tv/dooper\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">Dooper</a> added lots of his own personalized images into his own customized mtion space to match his theme and personality. This is a great way to showcase his sponsorship and also give credit to the people that worked on his various stream asset designs!",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 7,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_10.png"
            ],
            "paragraphAttr": []
        },
        {
            "paragraphicId": 8,
            "paragraphType": "text",
            "paragraphContent": "<a href=\"https://www.twitch.tv/skykamtheshark\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">Skykam the Shark</a> placed lots of her own collections of posters and artwork to make her neon mtion apartment uniquely her own.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 9,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_11.png",
                "/images/blog/gallery_6_12.png"
            ],
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 8,
        "sectionTitle": "Utilizing Chromakey and Green Screen",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "We made a video to showcase some amazing new creative ways to use green screen / chroma key technology with mtion studio. You'll see that green screen isn't just about adding a 2D background - it's a powerful tool that can help you create mind-blowing visual effects, interact with your audience, and take your streams to new heights of entertainment.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "To learn more about how to creatively green screen / chroma key in mtion studio, we highly recommend checking out this video: <a href=\"https://youtu.be/r82-lTn4WXM\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">https://youtu.be/r82-lTn4WXM </a>",
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 9,
        "sectionTitle": "Make the most out of mtion studio's amazing library of free 3D assets",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "Did you know that you can actually get your hands on a retro cabinet 3D model from the GGTV clubhouse in Castle Lament clubhouse? I know it sounds pretty bizarre, but it's actually really simple to set up. All you need to do is download each clubhouse in mtion studio, and voila! The 3D models that come with each clubhouse will automatically be stored in your asset library. From there, all you need to do is head to the \"Asset Browser\" and choose the 3D model you want to use in your brand-new favorite clubhouse. Easy peasy!",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_13.png"
            ],
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 10,
        "sectionTitle": "Play tricks on your mtion environment with image and video sources",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "You can add as many images and videos as you want in you mtion space, some could be your posters, fan arts, sponsorships etc., but what if you want an animated galaxy ceiling? ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "text",
            "paragraphContent": "In this <a href=\"https://drive.google.com/file/d/1U4-Sxo471idNJUu8ruho-S4dZypxvAiE/view?usp=share_link\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">mtion space</a>, simply adding a video of the galaxy and mapped it to the ceiling brought such a chill vibe to this set. ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 3,
            "paragraphType": "text",
            "paragraphContent": "<a href=\"https://youtu.be/jbAJB1OsudY\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\"> Check out Video Here! </a>",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 4,
            "paragraphType": "text",
            "paragraphContent": "Or, maybe have an environment of the game you are playing on a particular stream to sit right outside of your mtion apartment?",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 5,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_14.png"
            ],
            "paragraphAttr": []
        },
        {
            "paragraphicId": 6,
            "paragraphType": "text",
            "paragraphContent": " ",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 7,
            "paragraphType": "text",
            "paragraphContent": "Since you can play with the size of any input source, you can make this happen easily! ",
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 11,
        "sectionTitle": "Playing with Scale",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "One of the wonders of technology is that you’re not limited by the constructs of reality. What do we mean by this? Well, you have the power to grow and shrink whoever and whatever you want, pretty crazy. This means that you have a lot of creative freedom in terms of the scale of your virtual avatar and the relevant surroundings. <a href=\"https://www.twitch.tv/bignosebug\" class=\"underline text-blue-600 hover:text-blue-800 visited:text-purple-600\">BigNoseBug</a> on twitch demonstrated this by shrinking her avatar down and increasing the size of a house plant, to make it seem as though she was vibing in a houseplant forest. There’s a lot of potential for creating out of pocket and one of a kind streaming spaces, which will help you stand out from the competition.",
            "paragraphAttr": []
        },
        {
            "paragraphicId": 2,
            "paragraphType": "image",
            "paragraphContent": [
                "/images/blog/gallery_6_15.png"
            ],
            "paragraphAttr": []
        }
        ]
    },
    {
        "sectionId": 12,
        "sectionTitle": "Conclusion",
        "sectionContent": [{
            "paragraphicId": 1,
            "paragraphType": "text",
            "paragraphContent": "We hope that this guide has helped you level up your mtion skills, and that you had a good time seeing what other mtion users have been up to lately. We’re really excited to see what you’re going to create next, and would love for you to share your progress with us in our discord. Signing off mtionauts :) ",
            "paragraphAttr": []
        }]
    }
    ]
}

];

export { news_data, single_news_data };